module.exports = __webpack_public_path__ + "fonts/creo.45a49a32.woff";